import React, { memo } from 'react';
import {
    ArrowRight16Regular,
    BookOpen16Regular,
    Document16Regular,
    Eye16Regular,
    Folder16Regular,
    Notebook16Regular,
    ShieldError16Regular,
    Sparkle16Regular,
    TaskListSquareLtr16Regular,
} from '@fluentui/react-icons';
import { resolveActionDescription, resolveActionIconKey } from '../../utils/responseActionMeta';
import styles from './askAi.module.css';

const ICONS = {
    folder: Folder16Regular,
    task: TaskListSquareLtr16Regular,
    irl: Document16Regular,
    raid: ShieldError16Regular,
    evidence: Eye16Regular,
    document: Document16Regular,
    observation: Eye16Regular,
    action_log: Notebook16Regular,
    journal: BookOpen16Regular,
    follow_up: Sparkle16Regular,
    default: ArrowRight16Regular,
};

function ResponseActionChip({
    action,
    variant = 'secondary',
    disabled = false,
    onClick,
    ariaLabel,
}) {
    if (!action) return null;
    const iconKey = resolveActionIconKey(action.key);
    const Icon = ICONS[iconKey] || ICONS.default;
    const description = resolveActionDescription(action);
    const className =
        variant === 'primary' ? styles.responseActionChipPrimary : styles.responseActionChip;

    return (
        <button
            type="button"
            className={className}
            disabled={disabled}
            aria-label={ariaLabel || action.label}
            title={description || undefined}
            onClick={() => onClick?.(action)}>
            <Icon aria-hidden />
            <span className={styles.responseActionChipText}>
                <span className={styles.responseActionChipLabel}>{action.label}</span>
                {description ? (
                    <span className={styles.responseActionChipDescription}>{description}</span>
                ) : null}
            </span>
        </button>
    );
}

export default memo(ResponseActionChip);
